export function removeTelegramCredential(href: string): string {
  const url = new URL(href);
  url.searchParams.delete('telegram');
  return url.toString();
}

export function shouldRetainTelegramCredential(error: string): boolean {
  return error === 'conflict' || error === 'merge-conflict';
}
